//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from '@/mixins/index'
export default {
  name: 'HelloWorld',
  mixins: [mixin],
  data () {
    return {
      contentTwo: [
        {
          bg: 'content-1.png',
          name: 'DNAer实现了两个层面的颠覆',
          title: '底层系统颠覆 X 商业模式颠覆',
          block: [
            {
              name: '系统功能层面',
              title1: 'System Functional',
              title2: 'Level',
              english2Margin: '-58px',
              english: '基因数据个体的直连系统 '
            },
            {
              name: '商业模式层面',
              title1: 'Business model',
              title2: 'Level',
              english2Margin: '-58px',
              english: '数据资产系统系统'
            }
          ],
          notice1: '颠覆性产品，必定是从更底层、新维度进行颠覆',
          notice2: 'DNAer实现了系统功能层面和商业模式层面的颠覆',
          loading: 'DNAer COMING SOON...'
        },
        {
          bg: 'content-2.png',
          name: 'DNAer数据资产',
          title: '让一切人、服务自由连接',
          block: [
            {
              name: '真实个体，真实数据',
              title1: 'You create, You use',
              title2: 'You benefi',
              english: 'DNAer基于真实个体，真实数据',
              english2: '让个体与个体之间自有直连'
            },
            {
              name: '打破阻隔，自由直连',
              title1: 'Users are',
              title2: 'shareholders',
              english: '打破巨头的阻隔',
              english2Margin: '-58px',
              english2: '“直接对接——服务的提供者和消费者直接对接”'
            }
          ],
          notice1: '让所有个体与个体、个体与服务最低成本，',
          notice2: '最短路径自由直连 DNAer万亿级生态，造就新一代互联网地球村 : 亿万个体的崛起，个体',
          loading: 'DNAer COMING SOON...'
        }
      ],
      contentSix: [
        {
          bg: 'six-1.png',
          title1: '你的数据资产价值连城',
          title2: '流量价值归属自己',
          name1: '将流量资产价值回归',
          name2: '给个体用户',
          introduce1: '你创造、你使用、你受益。——   ',
          introduce2: '帮助用户创造属于自己价值连城的流量数据资产自平台',
          introduce3: '让数据的创造者、使用者成为数据的受益者。'
        },
        {
          bg: 'six-2.png',
          title1: '你与地球上任意个体',
          title2: '只有一条直线的距离',
          name1: '万物直连 ',
          name2: '自由社交',
          introduce1: '在DNAer，感受更广阔的世界，更自由的世界 ',
          introduce2: '在DNAer，更低成本更直接的点对点自由连接、自由社交',
          introduce3: '在DNAer，私密、开放都由用户自由定义'
        },
        {
          bg: 'six-3.png',
          title1: '在聊天这件事上 ',
          title2: '我们做得更好',
          name1: '新一代通讯 ',
          name2: '聊天软件',
          introduce1: '通讯、聊天合二为一——DNAer讯息系统。   ',
          introduce2: '品质控的福音，诸多聊天系统细节革命性迭代。',
          introduce3: '更爽洁的沟通体验，爱不释手。'
        },
        {
          bg: 'six-4.png',
          title1: '去中间化、去平台化 ',
          title2: '帮助个体崛起',
          name1: 'DNAer是容器 ',
          name2: '是用户生活操作系统',
          introduce1: 'DNAer是空间的提供者，',
          introduce2: 'DNAer是所有商业行为的包容者、组织者。',
          introduce3: ' DNAe给与亿万个体提供自由直连生态。'
        },
        {
          bg: 'six-5.png',
          title1: '新一代通讯社交 ',
          title2: '看我想看',
          name1: '看我想看 ',
          name2: '重新定义“朋友圈”',
          introduce1: '想看的，爱看的，才是我要的。   ',
          introduce2: '用户自由定义“朋友圈”。',
          introduce3: '是自闭者的私密空间，也是社交者的自由世界'
        },
        {
          bg: 'six-1.png',
          title1: '数据资产个体',
          title2: '自由连接生态',
          name1: '数据资产 ',
          name2: '连接你我',
          introduce1: 'DNAer是不同对象与个体的包容者、组织者',
          introduce2: '是亿万用户生活操作系统',
          introduce3: '拥有九大用户使用理由，优势竞争力'
        }
      ]
    }
  },
  mounted () {
    console.log(this.imgHost, 1)
  },
  methods: {
    handleToAbout () {
      this.$router.push({name: 'about'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/index.vue